import { create } from 'zustand';
import { UserPermissionType, UserProfile } from '../data-access/gql-types/graphql';

type Profile = {
  userId: string;
  email: string;
  firstName: string;
  userInitial: string;
  imageUrl: string;
};

type UserProfileStore = {
  meData: Profile;
  setMeData: (meData: Profile) => void;
  profileData: UserProfile | null;
  setProfileData: (profileData: UserProfile) => void;
  permissions: Record<string, Record<UserPermissionType, boolean>>;
  setPermissions: (permissions: Record<string, Record<UserPermissionType, boolean>>) => void;
  loadingUser: boolean;
  setLoadingUser: (loading: boolean) => void;
  shouldRefetchUserMe: boolean;
  refetchUserMe: () => void;
  resetRefetchUserMe: () => void;
  shouldRefetchUserProfile: boolean;
  refetchUserProfile: () => void;
  resetRefetchUserProfile: () => void;
};

export const useUserProfileStore = create<UserProfileStore>((set) => ({
  meData: {
    userId: '',
    email: '',
    firstName: '',
    userInitial: '',
    imageUrl: '',
  },
  setMeData: (meData: Profile) => set(() => ({ meData })),
  profileData: null,
  setProfileData: (profileData: UserProfile) => set(() => ({ profileData })),
  permissions: {},
  setPermissions: (permissions: Record<string, Record<UserPermissionType, boolean>>) => set(() => ({ permissions })),
  loadingUser: false,
  setLoadingUser: (loading: boolean) => set(() => ({ loadingUser: loading })),
  shouldRefetchUserMe: false,
  refetchUserMe: () => set(() => ({ shouldRefetchUserMe: true })),
  resetRefetchUserMe: () => set(() => ({ shouldRefetchUserMe: false })),
  shouldRefetchUserProfile: false,
  refetchUserProfile: () => set(() => ({ shouldRefetchUserProfile: true })),
  resetRefetchUserProfile: () => set(() => ({ shouldRefetchUserProfile: false })),
}));
